import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { Section, SectionTitle } from '@/components/landing/Section';

interface Testimonial {
  name: string;
  context: string;
  quote: string;
}

const TESTIMONIALS: Testimonial[] = [
  {
    name: 'María González',
    context: 'Villa Morra',
    quote:
      'Desde que instalamos el sistema de VISEP nos sentimos mucho más tranquilos. El monitoreo responde al instante.',
  },
  {
    name: 'Roberto Martínez',
    context: 'Electrónica RM',
    quote:
      'La seguridad de mi local mejoró totalmente. El personal es profesional y los reportes diarios son muy útiles.',
  },
  {
    name: 'Carmen Velázquez',
    context: 'Carmelitas',
    quote:
      'Excelente atención y tecnología de primer nivel. Recomiendo VISEP a cualquier familia que quiera estar protegida.',
  },
  {
    name: 'Juan Pablo Sosa',
    context: 'Estancia El Hornero',
    quote:
      'En el campo la seguridad es clave. Las rondas móviles y el monitoreo de VISEP nos dieron total tranquilidad.',
  },
];

function InitialsAvatar({ name }: { name: string }) {
  const initials = name
    .split(' ')
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('');
  return (
    <div
      className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/15 font-bold text-primary"
      aria-hidden
    >
      {initials}
    </div>
  );
}

export function Testimonials() {
  return (
    <Section id="testimonials">
      <SectionTitle subtitle="La confianza de quienes ya protegen lo que más quieren con VISEP.">
        Clientes que confían en nosotros
      </SectionTitle>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.5 }}
        className="group overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]"
      >
        <div className="flex w-max animate-[marquee_45s_linear_infinite] group-hover:[animation-play-state:paused] motion-reduce:animate-none">
          {[...TESTIMONIALS, ...TESTIMONIALS].map((t, i) => (
            <figure
              key={`${t.name}-${i}`}
              aria-hidden={i >= TESTIMONIALS.length || undefined}
              className="mr-6 flex w-80 shrink-0 flex-col rounded-2xl border border-white/[0.06] bg-white/[0.02] p-6 transition-colors hover:bg-white/[0.04]"
            >
              <div className="flex gap-0.5 text-primary" role="img" aria-label="5 de 5 estrellas">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-current" aria-hidden />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-400">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3">
                <InitialsAvatar name={t.name} />
                <div>
                  <p className="font-semibold text-white">{t.name}</p>
                  <p className="text-xs text-slate-400">{t.context}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </motion.div>
    </Section>
  );
}
